import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, LocPortal, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'ECommerce|Candidate|Purchase History';
const sharedProps = {
	htmlAllowed: false,
	shared: false,
	portal: 'SP' as LocPortal,
	feature: HubFeature.Ecommerce,
};

export type SPCandidatePurchaseHistoryLoc =
	| 'SPCandidatePurchaseHistoryPageTitle'
	| 'SPCandidatePurchaseHistorySectionTitle'
	| 'SPCandidatePurchaseHistoryStatusLabel'
	| 'SPCandidatePurchaseHistoryIdLabel'
	| 'SPCandidatePurchaseHistoryDatePurchasedLabel'
	| 'SPCandidatePurchaseHistoryNameLabel'
	| 'SPCandidatePurchaseHistoryCodeLabel'
	| 'SPCandidatePurchaseHistoryTypeLabel'
	| 'SPCandidatePurchaseHistoryPriceLabel'
	| 'SPCandidatePurchaseHistoryTypeFilterLabel'
	| 'SPCandidatePurchaseHistoryStatusFilterLabel'
	| 'SPCandidatePurchaseHistoryRefundButton';

export const spCandidatePurchaseHistoryLocs: LocDefs<SPCandidatePurchaseHistoryLoc> = {
	SPCandidatePurchaseHistoryPageTitle: {
		defaultValue: 'Purchase History',
		displayType: 'Title',
		description: 'Title for the Candidate Purchase History page',
		displayPath: `${dpRoot}|Title`,
		...sharedProps,
	},
	SPCandidatePurchaseHistorySectionTitle: {
		defaultValue: 'Purchase History',
		displayType: 'Title',
		description: 'Title for the Candidate Purchase History page',
		displayPath: `${dpRoot}|Title`,
		...sharedProps,
	},
	SPCandidatePurchaseHistoryStatusLabel: {
		defaultValue: 'Status',
		displayType: 'Label',
		description: 'Label for the status field in the Candidate Purchase History page.',
		displayPath: `${dpRoot}|Status Label`,
		...sharedProps,
	},
	SPCandidatePurchaseHistoryIdLabel: {
		defaultValue: 'ID',
		displayType: 'Label',
		description: 'Label for the ID field in the Candidate Purchase History page.',
		displayPath: `${dpRoot}|ID Label`,
		...sharedProps,
	},
	SPCandidatePurchaseHistoryDatePurchasedLabel: {
		defaultValue: 'Date Purchased',
		displayType: 'Label',
		description: 'Label for the date purchased field in the Candidate Purchase History page.',
		displayPath: `${dpRoot}|Date Purchased Label`,
		...sharedProps,
	},
	SPCandidatePurchaseHistoryNameLabel: {
		defaultValue: 'Name',
		displayType: 'Label',
		description: 'Label for the name field in the Candidate Purchase History page.',
		displayPath: `${dpRoot}|Name Label`,
		...sharedProps,
	},
	SPCandidatePurchaseHistoryCodeLabel: {
		defaultValue: 'Code',
		displayType: 'Label',
		description: 'Label for the code field in the Candidate Purchase History page.',
		displayPath: `${dpRoot}|Code Label`,
		...sharedProps,
	},
	SPCandidatePurchaseHistoryTypeLabel: {
		defaultValue: 'Type',
		displayType: 'Label',
		description: 'Label for the type field in the Candidate Purchase History page.',
		displayPath: `${dpRoot}|Type Label`,
		...sharedProps,
	},
	SPCandidatePurchaseHistoryPriceLabel: {
		defaultValue: 'Price',
		displayType: 'Label',
		description: 'Label for the price field in the Candidate Purchase History page.',
		displayPath: `${dpRoot}|Price Label`,
		...sharedProps,
	},
	SPCandidatePurchaseHistoryTypeFilterLabel: {
		defaultValue: 'Type',
		displayType: 'Label',
		description: 'Label for the type filter in the Candidate Purchase History page.',
		displayPath: `${dpRoot}|Type Filter Label`,
		...sharedProps,
	},
	SPCandidatePurchaseHistoryStatusFilterLabel: {
		defaultValue: 'Status',
		displayType: 'Label',
		description: 'Label for the status filter in the Candidate Purchase History page.',
		displayPath: `${dpRoot}|Status Filter Label`,
		...sharedProps,
	},
	SPCandidatePurchaseHistoryRefundButton: {
		defaultValue: 'Refund',
		displayType: 'Button',
		description: 'Button for the refund action in the Candidate Purchase History page.',
		displayPath: `${dpRoot}|Refund Button`,
		...sharedProps,
	},
};

export const spCandidatePurchaseHistoryLocKeys = MapLocKeys<SPCandidatePurchaseHistoryLoc>(
	spCandidatePurchaseHistoryLocs
);
export type SPCandidatePurchaseHistoryLocType = LocMap<SPCandidatePurchaseHistoryLoc>;
